export const SET_PROZESSE = "setProzesse";
